export default "__VITE_ASSET__573ee195__"